<template>
    <div>
        <HeaderMenu></HeaderMenu>
        <div class="my_courses_wrap profile_pages">
            <div class="container">
                <h1>My Courses</h1>
                <div class="row">
                    <div class="col-md-3">
                        <UserSidebarMenu></UserSidebarMenu>
                    </div>
                    <div class="col-md-9">
                        <div class="right_content">
                            <table class="table" v-if="orders!=null && orders.length">
                                <tbody>
                                <tr>
                                    <th>
                                        Order ID
                                    </th>
                                    <th>
                                        Sub Total
                                    </th>
                                    <th>
                                        Tax
                                    </th>
                                    <th>
                                        Total
                                    </th>
                                    <th>
                                        Payment Status
                                    </th>
                                    <th>
                                        Actions
                                    </th>
                                </tr>
                                <tr   v-for="order in orders">
                                    <td>
                                       {{ order.id }}
                                    </td>
                                    <td>
                                        SAR {{order.sub_total}}
                                    </td>
                                    <td>
                                        SAR {{order.tax}}
                                    </td>
                                    <td>
                                        SAR {{order.total}}
                                    </td>
                                    <td>
                                        <span class="status" :class="order.payment.status">
                                            {{order.payment.status}}
                                        </span>
                                    </td>
                                    <td>
                                        <router-link class="nav-link" v-bind:to="'/my-courses/'+order.id+'/'">
                                            View
                                        </router-link>
                                    </td>
                                </tr>
                               </tbody>
                            </table>
                            <div class="no-results-found text-center" v-if="orders.length < 1 && processing==false">
                                <span>
                                    No results found.
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import HeaderMenu from './../HeaderMenu'
import UserSidebarMenu from './UserSidebarMenu'
export default{
    name: 'MyCourses',
    components:{
        'HeaderMenu'     : HeaderMenu,
        'UserSidebarMenu': UserSidebarMenu
    },
    data() {
        this.getUser().then(res => {
            this.user = res;
            this.get_orders();
        })
        
        return {
            user:this.$store.state.auth.current_user,
            current_locale:this.$i18n_global.locale,
            orders:[],
            processing:true
        }
    },
    methods: {
        async getUser() {
            return this.$store.state.auth.current_user;
        },
        get_orders() {
            var _self = this;
            _self.processing = true;
            _self.$axios_global.post(this.$hostname+'/api/orders',{
                    id: _self.user.id
                })
                .then((res) => {
                    _self.processing = false;
                    _self.orders = res.data.orders;
                })
                .catch((error) => {
                    _self.processing = false;
                    this.errors = error.response.data;
                    return false;
                })
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/User/MyCourses.vue